/**
 * Image mapping system using ES module imports for production compatibility
 * Maps JSON paths to imported asset URLs that work in both dev and production
 */

// Import all images as ES modules
import cessnaHeroImage from '@/assets/images/cessna-170b-hero.png';
import liveHeroImage from '@/assets/images/hero-cessna-live.png';

// Import gallery images
import altonBayImage from '@/assets/images/gallery/alton_bay.jpg';
import altonBay2Image from '@/assets/images/gallery/alton_bay_2.jpg';
import campingImage from '@/assets/images/gallery/camping.jpg';
import fieldImage from '@/assets/images/gallery/field.jpg';
import fieldFlapsImage from '@/assets/images/gallery/field_flaps.jpg';
import formationImage from '@/assets/images/gallery/formation.jpg';
import fuelDockSunsetImage from '@/assets/images/gallery/fuel_dock_sunset.jpg';
import harbourImage from '@/assets/images/gallery/harbour.jpg';
import islandsImage from '@/assets/images/gallery/islands.jpg';
import keenBlackhawkImage from '@/assets/images/gallery/keen_blackhawk.jpg';
import kennyTailwheelEndorsementImage from '@/assets/images/gallery/kenny_tailwheel_endorsement.jpg';
import letsgoImage from '@/assets/images/gallery/letsgo.jpg';
import mattLunchImage from '@/assets/images/gallery/matt_lunch.jpg';
import studentImage from '@/assets/images/gallery/student.jpg';
import katamaMarthaVineyardImage from '@/assets/images/gallery/katama_martha_vineyard.jpg';
import winterSnowAircraftImage from '@/assets/images/gallery/winter_snow_aircraft.jpg';
import n3472cLandingAltonBayImage from '@/assets/images/gallery/n3472c_landing_alton_bay_b18.jpg';
import steveNTailwheelEndorsementImage from '@/assets/images/gallery/steve_n_tailwheel_endorsement.jpg';

// Import hangar direction images
import hangarDirectionsImage from '@/assets/images/hangar-directions.jpg';
import hangarDirectionsThumbImage from '@/assets/images/hangar-directions-thumb.jpg';

// Import blog images
import crowIslandMudImage from '@/assets/images/blog/nick_72c_crow_island_mud.jpg';
import altonBaySteveImage from '@/assets/images/blog/alton_bay_steve.jpg';
import altonBayZoeyCockpitImage from '@/assets/images/blog/alton_bay_zoey_cockpit.jpg';
import altonBayZoeyOnIceImage from '@/assets/images/blog/alton_bay_zoey_on_ice.jpg';
import thumbCrowIslandMudImage from '@/assets/images/blog/thumbs/nick_72c_crow_island_mud.jpg';
import thumbAltonBayImage from '@/assets/images/blog/thumbs/n3472c_landing_alton_bay_b18.jpg';
import thumbKatamaImage from '@/assets/images/blog/thumbs/katama_martha_vineyard.jpg';
import thumbCampingImage from '@/assets/images/blog/thumbs/camping.jpg';

// Import instrument panel images
import panelWideImage from '@/assets/images/panel/panel_wide.jpg';
import panelSwitchesImage from '@/assets/images/panel/panel_switches.jpg';
import panelGpsNavcommImage from '@/assets/images/panel/panel_gps_navcomm.jpg';

// Import team member photos
import mattImage from '@/assets/images/matt.jpeg';
import kevinImage from '@/assets/images/kevin.jpeg';

/**
 * Image mapping from JSON paths to imported asset URLs
 * This ensures proper asset handling in both development and production builds
 */
const imageMap: Record<string, string> = {
  '/assets/images/cessna-170b-hero.png': cessnaHeroImage,
  '/assets/images/hero-cessna-live.png': liveHeroImage,
  // Live site hero image path mapping
  './lovable-uploads/2ca92fa9-69a7-4c59-97d3-5f5b7eea759a.png': liveHeroImage,
  'lovable-uploads/2ca92fa9-69a7-4c59-97d3-5f5b7eea759a.png': liveHeroImage,
  
  // Gallery images
  '/assets/images/gallery/alton_bay.jpg': altonBayImage,
  '/assets/images/gallery/alton_bay_2.jpg': altonBay2Image,
  '/assets/images/gallery/camping.jpg': campingImage,
  '/assets/images/gallery/field.jpg': fieldImage,
  '/assets/images/gallery/field_flaps.jpg': fieldFlapsImage,
  '/assets/images/gallery/formation.jpg': formationImage,
  '/assets/images/gallery/fuel_dock_sunset.jpg': fuelDockSunsetImage,
  '/assets/images/gallery/harbour.jpg': harbourImage,
  '/assets/images/gallery/islands.jpg': islandsImage,
  '/assets/images/gallery/keen_blackhawk.jpg': keenBlackhawkImage,
  '/assets/images/gallery/kenny_tailwheel_endorsement.jpg': kennyTailwheelEndorsementImage,
  '/assets/images/gallery/letsgo.jpg': letsgoImage,
  '/assets/images/gallery/matt_lunch.jpg': mattLunchImage,
  '/assets/images/gallery/student.jpg': studentImage,
  '/assets/images/gallery/katama_martha_vineyard.jpg': katamaMarthaVineyardImage,
  '/assets/images/gallery/winter_snow_aircraft.jpg': winterSnowAircraftImage,
  '/assets/images/gallery/n3472c_landing_alton_bay_b18.jpg': n3472cLandingAltonBayImage,
  '/assets/images/gallery/steve_n_tailwheel_endorsement.jpg': steveNTailwheelEndorsementImage,
  
  // Blog images
  '/assets/images/blog/nick_72c_crow_island_mud.jpg': crowIslandMudImage,
  '/assets/images/blog/alton_bay_steve.jpg': altonBaySteveImage,
  '/assets/images/blog/alton_bay_zoey_cockpit.jpg': altonBayZoeyCockpitImage,
  '/assets/images/blog/alton_bay_zoey_on_ice.jpg': altonBayZoeyOnIceImage,
  '/assets/images/blog/thumbs/nick_72c_crow_island_mud.jpg': thumbCrowIslandMudImage,
  '/assets/images/blog/thumbs/n3472c_landing_alton_bay_b18.jpg': thumbAltonBayImage,
  '/assets/images/blog/thumbs/katama_martha_vineyard.jpg': thumbKatamaImage,
  '/assets/images/blog/thumbs/camping.jpg': thumbCampingImage,

  // Hangar directions images
  '/assets/images/hangar-directions.jpg': hangarDirectionsImage,
  '/images/hangar-directions.jpg': hangarDirectionsImage,
  '/assets/images/hangar-directions-thumb.jpg': hangarDirectionsThumbImage,
  '/images/hangar-directions-thumb.jpg': hangarDirectionsThumbImage,
  
  // Instrument panel images
  '/assets/images/panel/panel_wide.jpg': panelWideImage,
  '/images/panel/panel_wide.jpg': panelWideImage,
  '/assets/images/panel/panel_switches.jpg': panelSwitchesImage,
  '/images/panel/panel_switches.jpg': panelSwitchesImage,
  '/assets/images/panel/panel_gps_navcomm.jpg': panelGpsNavcommImage,
  '/images/panel/panel_gps_navcomm.jpg': panelGpsNavcommImage,
  
  // Team member photos
  '/assets/images/matt.jpeg': mattImage,
  '/assets/images/kevin.jpeg': kevinImage,
};

/**
 * Resolves image paths from JSON data to actual imported asset URLs
 * @param imagePath - Path from JSON data (e.g., "/assets/images/logo.png")
 * @returns Resolved asset URL that works in both dev and production
 */
export function resolveImagePath(imagePath: string): string {
  // First try exact match in image map
  if (imageMap[imagePath]) {
    return imageMap[imagePath];
  }

  // Try normalized paths (with and without /assets prefix)
  const normalizedPath = imagePath.startsWith("/assets/")
    ? imagePath
    : `/assets${imagePath.startsWith("/") ? imagePath : "/" + imagePath}`;

  if (imageMap[normalizedPath]) {
    return imageMap[normalizedPath];
  }

  // Try legacy path format
  const legacyPath = imagePath.replace("/assets", "");
  if (imageMap[legacyPath]) {
    return imageMap[legacyPath];
  }

  // Fallback: log warning and return original path
  console.warn(`Image not found in image map: ${imagePath}. Available images:`, Object.keys(imageMap));
  return imagePath;
}

/**
 * Get all available image paths for debugging
 */
export function getAvailableImages(): string[] {
  return Object.keys(imageMap);
}

/**
 * Legacy export for compatibility
 */
export const resolveImageUrl = resolveImagePath;
